import { createContext, useContext, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const add = (product, option = null, selections = null) => {
    const key = product.id + "|" + (option?.label ?? "") + "|" + (selections ? selections.join(";") : "");
    const min = product.min_qty ?? 1;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => i.key === key ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, {
        key,
        id: product.id,
        name: product.name,
        option: option?.label ?? null,
        selections: selections ?? null,
        price: option?.price ?? product.price,
        unit: product.unit,
        image: product.image,
        min_qty: min,
        qty: min,
      }];
    });
    setOpen(true);
  };

  const setQty = (key, qty) => {
    setItems((prev) => {
      const item = prev.find((i) => i.key === key);
      const min = item?.min_qty ?? 1;
      if (qty < min) return prev.filter((i) => i.key !== key);
      return prev.map((i) => i.key === key ? { ...i, qty } : i);
    });
  };

  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);
  const total = useMemo(() => items.reduce((s, i) => s + i.qty * i.price, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, setQty, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
